export enum WebinarItemName {
  NAME = 'name',
  STARTS_AT_DATE = 'starts_at_date',
  STARTS_AT_TIME = 'starts_at_time',
  STARTS_AT_TIME_ZONE = 'starts_at_time_zone',
  ROOM_LINK = 'room_link',
  ID = 'id',
}
